import "./Toaster.scss";

import React from 'react';
import { Toast } from 'react-bootstrap';
import { faCircleInfo, faInfo, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

type ToasterProps = {
    show: boolean;
    onClose: () => void;
    type: 'primary' | 'warning' | 'success' | 'danger' | 'interactive';
    message?: string;
    title: string;
    icon: string;
    addClass?: string;
    region?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
    closeButton?: boolean;
    autohide?: boolean;
    iconStyle?: string;
    acceptCallback?: ()=>void;
    acceptBtnText?: string;
};

export interface ToastConfig {
    type: 'primary' | 'warning' | 'success' | 'danger' | 'interactive';
    title: string;
    message?: string;
    icon: string;
    region?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
    closeButton?: boolean;
    autohide?: boolean;
    iconStyle?: string;
    acceptCallback?: ()=>void;
    acceptBtnText?: string;
}

const Toaster: React.FC<ToasterProps> = ({ show, onClose, type, message, title, icon, addClass, region="top-right", closeButton=true, autohide=true, iconStyle="",acceptCallback,acceptBtnText }) => {
    if (!show) return null;
    return (
        <Toast 
            className={`toast toast-${type} ${region} ${addClass ? addClass : "mt-12"}`}
            style={{ width: "380px" }}
            show={show}
            onClose={onClose}
            delay={3000}
            autohide={autohide}
        >
            <div className={`ps-3 ${iconStyle}`}>
                <span className={`material-symbols-outlined fs-30`}>{icon}</span>
            </div>
            <Toast.Body className='flex-fill'>
                {title && <div><strong>{title}</strong></div>}
                {type=="interactive"?
                (<>
                    <div className='fs-12 mt-1'>{message}</div>
                    <div className="d-flex mt-1 flex-row justify-content-between">
                        <span className="underline text-decoration-underline cursor-pointer" onClick={acceptCallback}>{acceptBtnText}</span> 
                        <span className="underline text-decoration-underline cursor-pointer" onClick={onClose}>Dismiss</span>
                    </div>
                </>):
                        (<div className='fs-12'>{message}</div>)
                }
            </Toast.Body>
            {closeButton&&<Toast.Header></Toast.Header>}
            
        </Toast>
    );
};

export default Toaster;